import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overlay-card__content" }

type EMITS = (e: 'closeOverlay') => void

export default /*@__PURE__*/_defineComponent({
  __name: 'OverlayCard',
  props: {
  backgroundTransparent: {
    type: Boolean,
    default: false
  }
},
  emits: ["closeOverlay"],
  setup(__props, { emit: __emit }) {

// The backgroundTransparent prop can be used if the OverlayCard is shown while an overlay modal is active

const emits = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["overlay-card__background", { 'overlay-card__background__transparent': __props.backgroundTransparent }]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emits('closeOverlay')), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})